let React    = require('react');
let ReactDom = require('react-dom');

// -------------------------------------------------------

class StaticSystemError extends React.Component {
  render() {
    return (
      <div id="login">
        <div className="login-box">
          <div className="login-logo" />

          <div className="box">
            <div className="auth0-notice">
              <span className="material-icons notice-icon">error_outline</span>
              <p className="notice-title">システムエラーが発生しました</p>
              <p className="notice-desc">
                しばらく経ってから再度お試しください。<br />
                解決しない場合は管理者にお問い合わせください。
              </p>
            </div>

            <a className="auth0-login-button" href="/">
              <span className="material-icons">home</span>
              トップページへ戻る
            </a>
          </div>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

export default StaticSystemError;
